import { render } from "./CameraModal.vue?vue&type=template&id=2d5c5b5e&scoped=true"
import script from "./CameraModal.vue?vue&type=script&lang=js"
export * from "./CameraModal.vue?vue&type=script&lang=js"

import "./CameraModal.vue?vue&type=style&index=0&id=2d5c5b5e&lang=css"
import "./CameraModal.vue?vue&type=style&index=1&id=2d5c5b5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5c5b5e"]])

export default __exports__